module.exports = __webpack_public_path__ + "img/lv21.5fd105fd.png";